export default function onUpload(
    file: File | null | undefined,
    setUploadedFile: (e: string) => void,
    allowedExtensions = ['jpg', 'png', 'jpeg']
) {
    const maxFilesizeMb = 5;

    if (typeof file === 'undefined' || file === null) {
        throw new Error('Undefined file');
    }

    const extension = file.name.split('.');

    if (extension) {
        // @ts-expect-error cano be undefined
        if (!allowedExtensions.includes(extension[extension.length - 1].toLowerCase())) {
            throw new Error('Unsupported extension');
        }
    }

    if (file.size > maxFilesizeMb * 1024 * 1024) {
        throw new Error('File too big');
    }

    const fileReader = new FileReader();

    fileReader.readAsDataURL(file);
    fileReader.onload = (_event) => {
        setUploadedFile(URL.createObjectURL(file));
    }
}
